module.exports = __webpack_public_path__ + "media/add-weights.e52bd03d.mp4";